/**
 * Bouton-icône Lucide — norme stack standard pour les actions de liste.
 * `title` obligatoire pour l'accessibilité.
 */
export default function IconButton({
  icon: Icon,
  title,
  onClick,
  disabled = false,
  color,
  size = 18,
  variant = 'ghost',
}) {
  if (!Icon) throw new Error('IconButton requiert un prop `icon` (composant Lucide)');
  if (!title) throw new Error('IconButton requiert un prop `title` pour accessibilité');

  const baseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0.35rem',
    borderRadius: 'var(--radius-sm)',
    border: '1px solid transparent',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.4 : 1,
    transition: 'background 0.15s ease',
    color: color ?? 'var(--text)',
  };

  const variants = {
    ghost: { background: 'transparent' },
    soft: { background: 'var(--glass)', border: '1px solid var(--glass-border)' },
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={title}
      style={{ ...baseStyle, ...variants[variant] }}
    >
      <Icon size={size} />
    </button>
  );
}
